import React, {
  memo,
  useCallback,
} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';

// icons
import IntegratedLogo from 'now-frontend-shared/assets/icons/white-now-pep-logo.svg';

// components
import BurgerMenu from 'components/BurgerMenu';
import HeaderMenu from '../HeaderMenu';
import Button from 'now-frontend-shared/components/Button';

// modals
import SignInModal from 'components/Modals/SignInModal';

// custom hooks
import { useModalSetter } from 'now-frontend-shared/hooks/useModal';

// styles and components from material-ui
import { withStyles } from '@material-ui/core/styles';
import { Grid, Link } from '@material-ui/core';
import SignupModal from 'components/Modals/SignupModal';

// styles
import styles from './styles';

const Header = ({
  classes,
  isAuthorized,
}) => {
  const { setModal } = useModalSetter();

  const handleModalOpen = useCallback(() => {
    setModal(<SignInModal />);
  }, [setModal]);

  const handleOpenSignUpPage = useCallback(() => {
    setModal(<SignupModal />);
  }, [setModal]);

  return (
    <Grid
      component="header"
      container
      justify="center"
      className={classes.header}
    >
      <Grid
        container
        alignItems="center"
        justify="space-between"
        className={classes.container}
      >
        <Grid item className={classes.burgerMenu}>
          <BurgerMenu />
        </Grid>

        <Grid item className={classes.logoContainer}>
          <img src={IntegratedLogo} alt="NOW-PEP Logo" className={classes.imgLogo} />
        </Grid>

        <Grid item className={classes.buttonContainer}>
          {isAuthorized ? (
            <HeaderMenu />
          ) : (
            <>
              <Grid item className={classes.linkContainer}>
                <Link href="/#overview_section" className={classes.linkText} data-cy="headerOverviewLink">
                  OVERVIEW
                </Link>
              </Grid>
              <Grid item className={classes.linkContainer}>
                <Link href="/#team_bio" className={classes.linkText} data-cy="headerTeamLink">
                  TEAM
                </Link>
              </Grid>
              <Grid item className={classes.button}>
                <Button
                  label="LOGIN"
                  data-cy="headerLoginButton"
                  buttonColor="white"
                  onClick={handleModalOpen}
                  className={classes.button}
                />
              </Grid>
              <Grid item className={classes.button}>
                <Button
                  label="REGISTER"
                  data-cy="headerRegisterButton"
                  buttonColor="white"
                  onClick={handleOpenSignUpPage}
                  className={classes.button}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

Header.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  isAuthorized: PropTypes.bool,
};

Header.defaultProps = {
  isAuthorized: undefined,
};

export default compose(
  connect(({ auth }) => ({
    isAuthorized: auth.authInfo.isAuthorized,
  })),
  withStyles(styles),
  memo,
)(Header);
